import { notification } from 'antd';
import { throttle } from 'lodash';

export const ANNO_TYPE_LAG = 'integrityAlignmentLag';

const productMap = {
  Ad: 'AD',
  EI: 'Video',
};

const notifyUser = throttle(
  (type) => {
    const productTitle = productMap[type];
    notification.error({
      message: `${productTitle} Lag detected`,
      description: `${productTitle} metric data is lagging right now and hence you may not see full data for all the metrics.
      Please remove the ${productTitle} metrics and refresh the page. Reach out to Conviva support for any help required.`,
      duration: 0, // do not auto close the notification
    });
  },
  5 * 60 * 1000,
); // once per 5m

export const handleDataLag = (annoInfo) => {
  const { impacted } = annoInfo.value;
  notifyUser(impacted);
};
